import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import pic02 from '../images/pic02.jpg';
import pic03 from '../images/pic03.jpg';
import ExitIcon from '../images/exit.svg';

import RapidDetoxSlides from './slides/RapidDetoxSlides';

const StyledArticle = styled.article`
  &:active {
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  h2 {
    margin-bottom: 0;
  }
`;

const ArticleContent = styled.span`
  height: 100%;
  margin: 1rem 0 !important;
`;

const CloseButton = styled.img`
  position: absolute;
  top: 2rem;
  right: 2rem;
  height: 3rem;

  &:hover {
    cursor: pointer;
    fill: black;
  }
`;

class Main extends React.Component {
  render() {
    const { onCloseArticle, timeout, article, articleTimeout } = this.props;
    const close = (
      <CloseButton
        src={ExitIcon}
        onClick={() => {
          onCloseArticle();
        }}
      />
    );

    return (
      <div
        id="main"
        style={
          timeout
            ? { display: 'flex', flexDirection: 'column' }
            : { display: 'none' }
        }
      >
        <StyledArticle
          id="rapid-detox"
          className={`${article === 'rapid-detox' ? 'active' : ''} ${
            articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Rapid Detox</h2>
          <ArticleContent className="image main">
            <RapidDetoxSlides />
          </ArticleContent>

          {close}
        </StyledArticle>

        <article
          id="hyperthermia-treatment"
          className={`${article === 'hyperthermia-treatment' ? 'active' : ''} ${
            articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Hyperthermia Treatment</h2>
          <span className="image main">
            <img src={pic02} alt="" />
          </span>
          <p>
            Adipiscing magna sed dolor elit. Praesent eleifend dignissim arcu,
            at eleifend sapien imperdiet ac. Aliquam erat volutpat. Praesent
            urna nisi, fringila lorem et vehicula lacinia quam. Integer
            sollicitudin mauris nec lorem luctus ultrices.
          </p>
          <p>
            Nullam et orci eu lorem consequat tincidunt vivamus et sagittis
            libero. Mauris aliquet magna magna sed nunc rhoncus pharetra.
            Pellentesque condimentum sem. In efficitur ligula tate urna.
            Maecenas laoreet massa vel lacinia pellentesque lorem ipsum dolor.
            Nullam et orci eu lorem consequat tincidunt. Vivamus et sagittis
            libero. Mauris aliquet magna magna sed nunc rhoncus amet feugiat
            tempus.
          </p>
          {close}
        </article>

        <article
          id="cool-head"
          className={`${article === 'cool-head' ? 'active' : ''} ${
            articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Cool-Head</h2>
          <span className="image main">
            <img src={pic03} alt="" />
          </span>
          <p>
            Adipiscing magna sed dolor elit. Praesent eleifend dignissim arcu,
            at eleifend sapien imperdiet ac. Aliquam erat volutpat. Praesent
            urna nisi, fringila lorem et vehicula lacinia quam. Integer
            sollicitudin mauris nec lorem luctus ultrices.
          </p>
          <p>
            Nullam et orci eu lorem consequat tincidunt vivamus et sagittis
            libero. Mauris aliquet magna magna sed nunc rhoncus pharetra.
            Pellentesque condimentum sem. In efficitur ligula tate urna.
            Maecenas laoreet massa vel lacinia pellentesque lorem ipsum dolor.
            Nullam et orci eu lorem consequat tincidunt. Vivamus et sagittis
            libero. Mauris aliquet magna magna sed nunc rhoncus amet feugiat
            tempus.
          </p>

          {close}
        </article>

        <article
          id="uvg"
          className={`${article === 'uvg' ? 'active' : ''} ${
            articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">UV Germicidal Device</h2>
          <span className="image main">
            <img src={pic02} alt="" />
          </span>
          <p>
            Adipiscing magna sed dolor elit. Praesent eleifend dignissim arcu,
            at eleifend sapien imperdiet ac. Aliquam erat volutpat. Praesent
            urna nisi, fringila lorem et vehicula lacinia quam. Integer
            sollicitudin mauris nec lorem luctus ultrices.
          </p>
          <p>
            Nullam et orci eu lorem consequat tincidunt vivamus et sagittis
            libero. Mauris aliquet magna magna sed nunc rhoncus pharetra.
            Pellentesque condimentum sem. In efficitur ligula tate urna.
            Maecenas laoreet massa vel lacinia pellentesque lorem ipsum dolor.
            Nullam et orci eu lorem consequat tincidunt. Vivamus et sagittis
            libero. Mauris aliquet magna magna sed nunc rhoncus amet feugiat
            tempus.
          </p>
          {close}
        </article>

        <article
          id="contact"
          className={`${article === 'contact' ? 'active' : ''} ${
            articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Contact</h2>
          <form method="post" action="#">
            <div className="field half first">
              <label htmlFor="name">Name</label>
              <input type="text" name="name" id="name" />
            </div>
            <div className="field half">
              <label htmlFor="email">Email</label>
              <input type="text" name="email" id="email" />
            </div>
            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea name="message" id="message" rows="4" />
            </div>
            <ul className="actions">
              <li>
                <input type="submit" value="Send Message" className="special" />
              </li>
              <li>
                <input type="reset" value="Reset" />
              </li>
            </ul>
          </form>
          {/* <ul className="icons"> */}
          {/* <li> */}
          {/* <a href="#" className="icon fa-twitter"> */}
          {/* <span className="label">Twitter</span> */}
          {/* </a> */}
          {/* </li> */}
          {/* <li> */}
          {/* <a href="#" className="icon fa-facebook"> */}
          {/* <span className="label">Facebook</span> */}
          {/* </a> */}
          {/* </li> */}
          {/* <li> */}
          {/* <a href="#" className="icon fa-instagram"> */}
          {/* <span className="label">Instagram</span> */}
          {/* </a> */}
          {/* </li> */}
          {/* <li> */}
          {/* <a href="#" className="icon fa-github"> */}
          {/* <span className="label">GitHub</span> */}
          {/* </a> */}
          {/* </li> */}
          {/* </ul> */}
          {close}
        </article>
      </div>
    );
  }
}

Main.propTypes = {
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  onCloseArticle: PropTypes.func,
  timeout: PropTypes.bool,
};

export default Main;
